(function () {
  Flint.file('mframework/views/paginator.js', function (require) {
    Flint.staticStyles('Paginator', {
      '$': '#_flintapp .ViewPaginator'
    }, {
      '$': {
        flexDirection: 'row'
      }
    });
    Flint.view('Paginator', function (view, on, $) {
      var pro = initPro(view, {
        initialPageIndex: M.defaultAtom(0),
        numPages: atom(),
        pageIndex: atom(),
        pageRadius: M.defaultAtom(2),
        style: M.mergeAtom({
          page: {
            padding: [8, 12],
            borderRadius: 8,
            border: '1px solid #eee',
            cursor: 'pointer',
            margin: 2,
            background: 'white',
            color: '#999'
          },
          selectedPage: {
            background: 'rgb(215, 98, 124)',
            fontWeight: 'bold',
            color: 'white'
          }
        })
      });

      var pageIndex = atom(pro.initialPageIndex.get());
      pro.pageIndex.react(function (propPageIndex) {
        if (propPageIndex != null) {
          pageIndex.set(propPageIndex);
        }
      });

      var requestPage = function requestPage(i) {
        if (pro.pageIndex.get() == null) {
          pageIndex.set(i);
        }

        if (view.props.onSelect) {
          view.props.onSelect({ page: i });
        }
      };view.render(function () {
        return Flint.iff(pageIndex.get() > 0) && view.el(
          ['prevSec', 1],
          { if: pageIndex.get() > 0,
            style: pro.style.get().get('page').toJS(),
            onClick: function () {
              return requestPage(pageIndex.get() - 1);
            }
          },
          '<'
        );
      });view.render(function () {
        return Flint.iff(pro.numPages.get() > 1) && Flint.range(2 * pro.pageRadius.get() + 1).map(function (_, _index) {
          return view.el(
            ['pageSecWrapper', 1, _, _index],
            { if: pro.numPages.get() > 1, repeat: 2 * pro.pageRadius.get() + 1 },
            Flint.iff(pageIndex.get() - pro.pageRadius.get() + _index >= 0 && pageIndex.get() - pro.pageRadius.get() + _index < pro.numPages.get()) && view.el(
              ['pageSec', 1, _, _index],
              {
                if: pageIndex.get() - pro.pageRadius.get() + _index >= 0 && pageIndex.get() - pro.pageRadius.get() + _index < pro.numPages.get(),
                onClick: function () {
                  return requestPage(pageIndex.get() - pro.pageRadius.get() + _index);
                },
                style: pro.style.get().get('page').merge(pageIndex.get() - pro.pageRadius.get() + _index == pageIndex.get() ? pro.style.get().get('selectedPage') : {}).toJS()
              },
              pageIndex.get() - pro.pageRadius.get() + _index + 1
            )
          );
        });
      });view.render(function () {
        return Flint.iff(pageIndex.get() < pro.numPages.get() - 1) && view.el(
          ['nextSec', 1],
          { if: pageIndex.get() < pro.numPages.get() - 1,
            style: pro.style.get().get('page').toJS(),
            onClick: function () {
              return requestPage(pageIndex.get() + 1);
            }
          },
          '>'
        );
      });
    });
  })
})();
//# sourceMappingURL=paginator.js.map
